import {
    listClips as listClipsAction,
    saveClipFailure,
    saveClipRequest,
    saveClipSuccess,
} from "../actions";
import { IClip } from "../api";
import { ThunkAction } from "../types";


export function saveClip(clip: IClip): ThunkAction {
    return async (dispatch, _2, {subtitles}) => {
        try {
            dispatch(saveClipRequest(clip));

            const result = await subtitles.saveClip(clip);

            dispatch(saveClipSuccess(result));
        } catch (error) {
            dispatch(saveClipFailure(error, clip));
        }
    };
}

export function listClips(): ThunkAction {
    return async (dispatch, _2, {subtitles}) => {
        try {
            dispatch(listClipsAction.request());

            const clips = await subtitles.listClips();

            dispatch(listClipsAction.success(clips));
        } catch (error) {
            dispatch(listClipsAction.failure(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/thunks/clipThunks.ts